import { render, staticRenderFns } from "./billboardBannerBottom.vue?vue&type=template&id=b6fb15fa&scoped=true&"
import script from "./billboardBannerBottom.vue?vue&type=script&lang=js&"
export * from "./billboardBannerBottom.vue?vue&type=script&lang=js&"
import style0 from "./billboardBannerBottom.vue?vue&type=style&index=0&id=b6fb15fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fb15fa",
  null
  
)

export default component.exports